import { useSelector } from 'react-redux';
import { useIsNative } from '~/context/common/DeviceContext';
import { getVehicleDetails } from '~/selectors';
import type { IfElse } from '~/types';
import generateSearchLinkFilter from '~/utilities/generateSearchFilterLink';

export type FiltersV1 = {
  freeText: string;
};

export type FiltersV2 = {
  makes: Array<{
    name: string;
    models: Array<{
      name: string;
    }>;
  }>;
};

export type CvnaId<Filters> = {
  filters: Filters & {
    isFreeDelivery?: boolean;
  };
};

export default function useMakeModelSearchLink(withFreeDelivery = false) {
  const isNative = useIsNative();
  const { make = '', model = '' } = useSelector(getVehicleDetails);
  const filtersObject: CvnaId<IfElse<typeof isNative, FiltersV1, FiltersV2>> =
    isNative
      ? {
          filters: {
            freeText: `${make} ${model}`
          }
        }
      : {
          filters: {
            makes: [{ name: make, models: [{ name: model }] }]
          }
        };

  if (withFreeDelivery) {
    filtersObject.filters.isFreeDelivery = true;
  }

  return generateSearchLinkFilter(filtersObject);
}
